import React, { useEffect, useRef, useState, useCallback } from "react";
import Webcam from "react-webcam";
import styled from "styled-components";
import config from "../config/config";
import { sendMessageToServer } from '../services/apiService';  // Importa il metodo
//import ErrorBoundary from './ErrorBoundary';



import titolo from "../images/titolo_realtime.png";
import newscan from "../images/btn_newscan.png";

const Wrapper = styled.div`
  display: block;
  margin: 0 auto;
  background: rgba(255,255,255);
`;

const container = {
  margin: 0,
  padding: 0,
  backgroundColor: '#000',
  width: '100%',
  height: '300px',
  
  // modifiche per nuova grafica da controllare se continua a funzionare l'OCR
  borderRadius: '15px',
  width: '300px',
  margin: 'auto'
  
};

const videocontainer = {
  margin: 'auto',
  width: '300px',
  height: '300px',
  overflow: 'hidden',
  position: 'relative',
  boxSizing: 'border-box',
  
    // modifiche per nuova grafica da controllare se continua a funzionare l'OCR
  borderRadius: '15px',
};

const video = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%) scale(1)',
  width: 'auto',
  height: 'auto',
  
  
};

const msg = {
  position: 'absolute',
  bottom: '0',
  left: '0',
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  color: 'white',
  padding: '5px',
  borderRadius: '3px',
  fontSize: '10px',
};


const BlurOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(1px);
  -webkit-backdrop-filter: blur(1px);
  pointer-events: none;
  mask-image: radial-gradient(circle at center, transparent 100px, black 100px);
`;

const Cross = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100px;
  height: 100px;
  transform: translate(-50%, -50%);
  display: flex;
  justify-content: center;
  align-items: center;

  &::before, &::after {
    content: '';
    position: absolute;
    background: gray;
  }

  &::before {
    width: 100px;
    height: 1px;
  }

  &::after {
    width: 1px;
    height: 100px;
  }
`;

const ArticleColumns = styled.div`
	clear: both;
`;

const ClearDiv = styled.div`
	clear: both;
`;

const ArticleDescContainer = styled.div`
	width: 70%;
	padding: 5px;
	float: left;
`;
const ArticleImgContainer = styled.div`
	float: left;
	max-width: 80px;
    max-height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
	
`;

const ArticleImg = styled.img`
    max-width: 100%;
    max-height: 100%;
    height: auto;
    width: auto;
	border: 1px solid #CCC;
	border-radius: 5px;
`;


const ArticleDiv = styled.div`
	border: 1px solid #ccc;
	border-radius: 5px;
	padding: 5px;
	margin: 3px auto;
	width: 90%;
	textAlign: center;
	background: rgba(230,230,230);
`;

const ArticleTitle = styled.h1`
	font-family: 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
	margin: 5px auto;
	font-size: 1em;
`;

const PriceDisclaimer = styled.p`
	margin: 5px auto;
	font-size: 0.7em;
`;

const ArticleDesc = styled.p`
	margin: 5px auto 10px auto;
	font-size: .8em;
`;

const ArticleNota = styled.p`
	margin: 5px auto 10px auto;
	font-size: .7em;
	font-style: italic;
`;

const ArticleNotActive = styled.p`
	margin: 5px auto 10px auto;
	font-size: .8em;
	color: #F00;
`;

const ArticleLink = styled.button`
  background-color: #F99; 
  color: #fff; 
  border: none;
  padding: 10px;
  margin: 0 5px;
  border-radius: 5px;
  text-decoration: none;
  cursor: pointer;
  display: inline-block;
  font-size: 1em;
`;

const SectionDiv = styled.div`
	border: 1px solid #ccc;
	border-radius: 5px;
	padding: 5px;
	margin: 3px auto;
	width: 90%;
	textAlign: center;
	background: rgba(255,255,255);
`;

const CaptureButton = styled.button`
  background-color: ${props => props.active ? 'green' : '#CCC'};
  color: ${props => props.active ? '#FFF' : '#333'};
  border: none;
  padding: 10px;
  margin: 5px 5px;
  border-radius: 5px;
  cursor: ${props => props.active ? 'default' : 'pointer'};
  display: inline-block;
  font-size: 1em;
`;

const FlashButton = styled.button`
  //position: absolute;
  //top: 10px;
  //right: 10px;
  background-color: ${props => props.active ? 'yellow' : '#333'};
  color: ${props => props.active ? '#000' : '#fff'};
  border: none;
  padding: 10px;
  margin: 0 5px;
  border-radius: 5px;
  cursor: ${props => props.active ? 'default' : 'pointer'};
`;

const AutofocusButton = styled.button`
  //position: absolute;
  //top: 10px;
  //right: 10px;
  background-color: ${props => props.active ? 'yellow' : '#333'};
  color: ${props => props.active ? '#000' : '#fff'};
  border: none;
  padding: 10px;
  margin: 0 5px;
  border-radius: 5px;
  cursor: ${props => props.active ? 'default' : 'pointer'};
`;

const ZoomButton = styled.button`
  //position: absolute;
  //top: 10px;
  //right: 10px;
  background-color: ${props => props.active ? 'yellow' : '#333'};
  color: ${props => props.active ? '#000' : '#fff'};
  border: none;
  padding: 10px 15px;
  margin: 0 10px;
  border-radius: 5px;
  cursor: ${props => props.active ? 'default' : 'pointer'};
`;

function formatArticleLink(articolo) {
  return articolo.replace(/\//g, '-');
}

//function useIsIphone() {
//  const [isIphone, setIsIphone] = useState(false);
//
//  useEffect(() => {
//    const userAgent = window.navigator.userAgent || window.navigator.vendor || window.opera;
//
//    // Verifica se l'user agent contiene 'iPhone'
//    if (/iPhone/i.test(userAgent)) {
//      setIsIphone(true);
//    } else {
//      setIsIphone(false);
//    }
//  }, []);
//
//  return isIphone;
//}

// Funzione per determinare se l'utente sta usando un iPhone
function isIphone() {
  const userAgent = window.navigator.userAgent || window.navigator.vendor || window.opera;
  return /iPhone/i.test(userAgent); // Restituisce true se è un iPhone
}



export default function Viewer() {
	
	
	
	
  const webcamRef = useRef(null);
  const [results, setResults] = useState([]);
  const [overlayMessage, setOverlayMessage] = useState('');
  const [prevMessage, setPrevMessage] = useState([]);
  const [socket, setSocket, getSocket] = useState(null);
  const client_id = Date.now();
  const [scale, setScale] = useState(1);
  const [stream, setStream] = useState(null);
  
  const [imageCapture, setImageCapture] = useState(null);
  const [cameras, setCameras] = useState([]);
  const [selectedCamera, setSelectedCamera] = useState(null);
  const [isCameraInUse, setIsCameraInUse] = useState(false); // Track camera 
  
  const [supportsZoom, setSupportsZoom] = useState(false); // Stato per il supporto dello zoom
  const [zoomRange, setZoomRange] = useState({ min: 0, max: 0 });
  const [zoom, setZoom] = useState(0);
  
  const [supportsFlash, setSupportsFlash] = useState(false); // Stato per il supporto del flash
  const [flashOn, setFlashOn] = useState(false);
  
  const [supportsAutofocus, setSupportsAutofocus] = useState(false); // Stato per il supporto dell'autofocus
  const [autofocusOn, setAutofocusOn] = useState(false);
  const [focusDistance, setFocusDistance] = useState(0);
  
  const [captureBtnEnabled, setCaptureBtnEnabled] = useState(false);
  //const [isIosDevice, setIsIosDevice] = useState(false);


  const videoContainerHeight = 200;
  const videoContainerWidth = 300;
  const cropFactorHeight = 6;
  const cropFactorWidth = 2;
  
  //const socketTimer = 2000;

  const updateResults = (message) => {
    setResults(results => [...results, ...message]);
  };
  
  const maxResults = 5;

  const addOverlayMessage = (newMessage) => {
    setOverlayMessage(prev => `${prev}\n${newMessage}`);
  };
  
  //const isIphone = useIsIphone();

  const [isIphoneDevice, setIsIphoneDevice] = useState(false);
  useEffect(() => {
	setIsIphoneDevice(isIphone()); // Imposta lo stato in base al risultato della funzione
  }, []);

const capture = (web, iphone) => {
	
    console.log("Capture function invoked 1 => " + selectedCamera);
	console.log("Capture function invoked 2 => " + webcamRef);
	console.log("is isIphoneDevice: "+isIphoneDevice)
	console.log("is iPhone: "+iphone)

	
	
    if ((selectedCamera || isIphoneDevice || iphone) && webcamRef.current) {
      const fullImage = webcamRef.current.getScreenshot();
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');

      const img = new Image();
      img.src = fullImage;

      img.onload = () => {
        const imgWidth = img.width;
        const imgHeight = img.height;

        const cropWidth = imgWidth / cropFactorWidth;
        const cropHeight = imgHeight / cropFactorHeight;

        const sx = (imgWidth - cropWidth) / 2;
        const sy = (imgHeight - cropHeight) / 2;

        canvas.width = cropWidth;
        canvas.height = cropHeight;

        ctx.drawImage(img, sx, sy, cropWidth, cropHeight, 0, 0, cropWidth, cropHeight);

        const capturedImg = canvas.toDataURL('image/jpeg');
        const data = JSON.stringify({ data: capturedImg });

        //console.log("Captured image data:", data);

		
		
        if (web && web.readyState === WebSocket.OPEN) {
          web.send(data);
          console.log("Image data sent to WebSocket");
        } else {
          console.error("WebSocket is not open or not defined");
		  addOverlayMessage(`WebSocket error`);

        }
		
      };
    } else {
      console.warn("Selected camera or webcam reference not available");

    }
};


/*
const creaSocket = () => {
	
    
};
*/


  useEffect(() => {
	//console.log("TTTTTTTTTTTTTTTTTTTTTTTTTTTTTT");
	

	
    const getCameras = async () => {
      try {
        const devices = await navigator.mediaDevices.enumerateDevices();
        const videoDevices = devices.filter(device => device.kind === 'videoinput');
        setCameras(videoDevices);
      } catch (error) {
        console.error('Error fetching cameras:', error);
        addOverlayMessage(`Error fetching cameras: ${error}`);
      }
    };
    getCameras();
  }, []);

  const handleCameraChange = async (event) => {
	  
	  //console.log("CCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCC "+event.target.value);
    const deviceId = event.target.value;
    setSelectedCamera(deviceId);
	setIsCameraInUse(true);
	
	//setOverlayMessage(`Cambio camera: `);

    // Chiudi il stream precedente, se esistente
    if (stream) {
      stream.getTracks().forEach(track => track.stop());
      setStream(null);
      setImageCapture(null);
    }

    const constraints = {
      deviceId: { exact: deviceId },
      height: { min: 600, ideal: 2000 },
      width: { min: 600, ideal: 2000 },
    };

	try {
		const newStream = await navigator.mediaDevices.getUserMedia({ video: constraints });
		setStream(newStream);
		const track = newStream.getVideoTracks()[0];
		
		// Create an ImageCapture instance
		// Check if ImageCapture is available
    if (typeof ImageCapture !== 'undefined') {
      // Create an ImageCapture instance
      const newImageCapture = new ImageCapture(track);
      setImageCapture(newImageCapture);
		
		// Get capabilities using ImageCapture
		const capabilities = await newImageCapture.getPhotoCapabilities();
		
		// Check if the camera supports flash
		setSupportsFlash(capabilities.torch);
		
		// Check if the camera supports autofocus
		setSupportsAutofocus(capabilities.focusMode);
		setAutofocusOn(capabilities.focusMode);
		
		// Check if the camera supports zoom
		if (capabilities.zoom) {
			const { min, max } = capabilities.zoom;
			setSupportsZoom(true);
			setZoomRange({ min, max });
		} else {
			setSupportsZoom(false);
		}
	} else {
      console.warn('ImageCapture API is not available in this browser.');
    }
		
	} catch (error) {
		console.error('Error switching camera:', error);
		alert(`Error switching camera: ${error}`);
	}
  };
  
  
  const selectCameraForIos = async () => {
	  
	let deviceId;
    if (cameras.length > 0) {
      const rearCamera = cameras.find((camera) =>
     	  camera.label.toLowerCase().includes('back')
      );
     
      if (rearCamera) {
     	  deviceId = rearCamera.deviceId;
      } else {
     	  // Se non c'è una fotocamera posteriore, seleziona la prima disponibile
     	  deviceId = cameras[0].deviceId;
      }
	}
	
	
	// parte che è ripetuta, potrebbe essere inserita in un metodo
	
	// Chiudi il stream precedente, se esistente
    if (stream) {
      stream.getTracks().forEach(track => track.stop());
      setStream(null);
      setImageCapture(null);
    }

    const constraints = {
      deviceId: { exact: deviceId },
      height: { min: 600, ideal: 2000 },
      width: { min: 600, ideal: 2000 },
    };

    try {
	  const newStream = await navigator.mediaDevices.getUserMedia({ video: constraints });
      setStream(newStream);
      const track = newStream.getVideoTracks()[0];
 //     const newImageCapture = new ImageCapture(track);
 //     setImageCapture(newImageCapture);

      // Verifica se la fotocamera supporta il flash
      const capabilities = track.getCapabilities();
	  //addOverlayMessage(`capabilities.torch: ${capabilities.torch}`);
      setSupportsFlash(capabilities.torch);
	  
	  //addOverlayMessage(`capabilities.focusMode: ${capabilities.focusMode}`);
	  setSupportsAutofocus(capabilities.focusMode);
	  setAutofocusOn(capabilities.focusMode);
	  
	  
	    // Verifica se la fotocamera supporta lo zoom
		  if (capabilities.zoom) {
			const { min, max } = capabilities.zoom;
			setSupportsZoom(true);
			setZoomRange({ min, max });
		  } else {
			setSupportsZoom(false);
		  }
	  
    } catch (error) {
      console.error('Error switching camera FOR IOS:', error);
      alert(`Error switching camera FOR IOS: ${error}`);
    }
	
	
	
  }
  
  
  
  
  
  

  const toggleFlash = async () => {
	  //addOverlayMessage(`toggleFlash:  ${flashOn} ${stream}`);
    if (flashOn && stream) {
		//addOverlayMessage(`spengo`);
      const track = stream.getVideoTracks()[0];
      await track.applyConstraints({ advanced: [{ torch: false }] });
      setFlashOn(false);
    } else if (stream) {
		//addOverlayMessage(`accendo`);
      const track = stream.getVideoTracks()[0];
      await track.applyConstraints({ advanced: [{ torch: true }] });
      setFlashOn(true);
    }
  };
  
  const toggleAutofocus = async () => {
	  //addOverlayMessage(`toggleFlash:  ${flashOn} ${stream}`);
    if (autofocusOn && stream) {
		//addOverlayMessage(`spengo`);
      const track = stream.getVideoTracks()[0];
      await track.applyConstraints({ advanced: [{ focusMode: 'manual' }] });
      setAutofocusOn(false);
    } else if (stream) {
		//addOverlayMessage(`accendo`);
      const track = stream.getVideoTracks()[0];
      await track.applyConstraints({ advanced: [{ focusMode: 'continuous' }] });
      setAutofocusOn(true);
    }
  };
  
  const handleZoomChange = (newZoom) => {
    if (stream && supportsZoom) {
      const track = stream.getVideoTracks()[0];
      const constraints = { advanced: [{ zoom: newZoom }] };
      track.applyConstraints(constraints);
      setZoom(newZoom);
    }
  };


  const handleLoadedMetadata = useCallback(() => {
    //console.log("FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF");
    if (webcamRef.current) {
      const videoWidth = webcamRef.current.video.videoWidth;
      const videoHeight = webcamRef.current.video.videoHeight;

      const scaleWidth = videoContainerWidth / videoWidth;
      const scaleHeight = videoContainerHeight / videoHeight;
      const newScale = Math.max(scaleWidth, scaleHeight);
      setScale(newScale);

      //
      //setTimeout(() => capture(socket), 2000);
	  capture(socket,selectedCamera);
      //addOverlayMessage(`Video: ${videoWidth} x ${videoHeight} Scala: ${newScale}`);

 
 

      return () => {
       // if (ws) ws.close();
      };
    }
  }, [client_id, prevMessage, capture]);



  const startCapture = async () => {
	  if (captureBtnEnabled)
	  {
		  setResults([]);
		  capture(socket);
	  }
  };



  const [cameraPermission, setCameraPermission] = useState(null); // Stato del permesso della fotocamera
  const [error, setError] = useState(null); // Stato per gestire eventuali errori

  // Funzione per richiedere accesso alla fotocamera
  const requestCameraAccess = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: true });
      setCameraPermission('granted');
      setError(null);
      console.log('Accesso alla fotocamera concesso');
      // Puoi fare altre operazioni con lo stream, come visualizzarlo in un <video>
    } catch (err) {
      setError('Errore durante la richiesta della fotocamera.');
      console.error(err);
    }
  };





  useEffect(() => {
	  
	  setOverlayMessage(``);
	  
	  
	  
	const checkCameraPermission = async () => {
		try {
			
		
			// Check if the browser supports getUserMedia
			if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
				throw new Error('getUserMedia is not supported in this browser.');
			}
		
			// Attempt to get camera access
			const stream = await navigator.mediaDevices.getUserMedia({ video: true });
		
			// If successful, set permission state
			setCameraPermission('granted');
		
			// Use the stream as needed (e.g., display it in a video element)
			// videoElement.srcObject = stream;
		
			// Stop all tracks if you only want to check permissions
			stream.getTracks().forEach(track => track.stop());
			
		
		} catch (err) {
			if (err.name === 'NotAllowedError') {
			setCameraPermission('denied');
			} else if (err.name === 'NotFoundError') {
			setCameraPermission('not found');
			} else {
			setError('Errore durante la verifica dei permessi.' + err);
			}
			console.error(err);
		}
		
	};

		if (!isCameraInUse) {
			checkCameraPermission(); // Only call if camera is not in use
		}
	

	  
	  //console.log("AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA");
	  
	  //isIOS();
	  //console.log("IPHONE: "+isIosDevice);
      //sendMessageToServer("IPHONE: "+isIosDevice);
	  //setIsIosDevice(true);
	  
	   
	  
	  if(socket != null)
	  {
		//console.log("WebSocket connection closed IIIIIIIIII: ");

		socket.close();
	  }
	  
	  
	  //if(socket == null)
	  {
			  // Apri la connessione WebSocket solo dopo che il video è stato inizializzato
			  const url = `${config.WS_SERVER}/${client_id}`;
			  const ws = new WebSocket(url);
			  //const referenceString = Object.prototype.toString.call(ws.current);


			  ws.onopen = () => {
				  /*
  				 console.log("WebSocket connection closed: ", referenceString);
				  
				  if(socket != null)
				  {
					console.log("WebSocket connection closed IIIIIIIIII: ", Object.prototype.toString.call(socket.current));

					socket.close();
				  }
				  */
				  
				console.log("WebSocket opened ");
				setOverlayMessage(``);
				setSocket(ws);
				//setTimeout(() => capture(), 2000);
			  };

			  ws.onerror = (error) => {
				console.error("WebSocket error:", error);
				addOverlayMessage(`WebSocket error: ${error.message || error}`);
				
			  };

			  ws.onclose = (event) => {
				console.log("WebSocket connection closed:", event.code, event.reason);
				
				
				if (event.code == '1012'){
					alert("Connessione terminata lato server, l'applicazione viene riavviata");
					window.location.reload();
				}
				
				//addOverlayMessage(`WebSocket connection closed: Code ${event.code}, Reason ${event.reason}`);
				
				
				
				// Tentativo di riconnessione dopo un intervallo
				/*
				setTimeout(() => {
				  const newWs = new WebSocket(url);
				  setSocket(newWs);
				  console.error("WebSocket riaperto dopo errore");
				}, socketTimer);
				*/
				
				
			  };

			ws.onmessage = (event) => {
			  console.log("ricevuta risposta");
			  try {
				const message = JSON.parse(event.data);
				if (!Object.keys(message).length) {
				  console.log("no data found");
				  capture(ws,isIphone());
				} else {
				  console.log(message);
				  const areEqual = JSON.stringify(prevMessage) === JSON.stringify(message);
				  if (!areEqual) {
					setPrevMessage(message);
					setResults(results => {
					  var updatedMessages = [...message, ...results];
					  if (updatedMessages.length > maxResults) {
						updatedMessages = updatedMessages.slice(0, maxResults);
					  }
					  setCaptureBtnEnabled(true);
					  return updatedMessages;
					});
				  }
				}
			  } catch (error) {
				console.error("Error parsing message:", error);
				capture(ws);
			  }
			  
			};	  
	  }
  }, [ selectedCamera]);

  const videoConstraints = {
  //  width: 200,
  //  height: 400,
	width: 1600,
    height: 1600,
    facingMode: "environment",
	resizeMode: false,
	// da 0 a 1 con 1 max Quality
    screenshotQuality: 1,
	forceScreenshotSourceSize: true
  };
  


  return (
    <Wrapper>
	
	<h1>Real Time</h1>
	
	{isIphoneDevice && (
	
		<div>
		<p>Stai usando un iPhone!</p> 
			<div style={{ ...container, height: `${videoContainerHeight}px` }}>
				<div style={{ ...videocontainer, height: `${videoContainerHeight}px`, width: `${videoContainerWidth}px` }}>
				  <Webcam
				  	style={{ ...video, transform: `translate(-50%, -50%) scale(${scale})` }}
					audio={false}
					ref={webcamRef}
					screenshotFormat="image/jpeg"
					width="100%"
					height="50%"
					videoConstraints={videoConstraints}
					onLoadedMetadata={handleLoadedMetadata}
				  />
				</div>
			</div>
		</div>
	)}
		  

	{!isIphoneDevice && (
			  <div style={{ ...container, height: `${videoContainerHeight}px` }}>
				<div style={{ ...videocontainer, height: `${videoContainerHeight}px`, width: `${videoContainerWidth}px` }}>
				  {selectedCamera && (
					<Webcam
					  style={{ ...video, transform: `translate(-50%, -50%) scale(${scale})` }}
					  audio={false}
					  ref={webcamRef}
					  screenshotFormat="image/jpeg"
					  videoConstraints={{ deviceId: { exact: selectedCamera } }}
					  onLoadedMetadata={handleLoadedMetadata}
					/>
				  )}
				  <BlurOverlay />
				  <Cross />
				  {overlayMessage.length > 0 && (
					<div style={msg}>{overlayMessage}</div>
				  )}
				</div>
			  </div>
	)}
			  {!isIphoneDevice && cameras.length > 0 && (
				<SectionDiv>
				  <label htmlFor="camera">Camera: </label>
				  <select id="camera" value={selectedCamera || ''} onChange={handleCameraChange}>
					<option value="">Scegli</option>
					{cameras.map((camera, index) => (
					  <option key={index} value={camera.deviceId}>
						{camera.label || `Camera ${index + 1}`}
					  </option>
					))}
				  </select>
				</SectionDiv>
			  )}


			  {!isIphoneDevice && supportsZoom && (  
				<SectionDiv>
				<label htmlFor="zoom">Zoom: </label>
				  <ZoomButton onClick={() => handleZoomChange(Math.max(zoom - 1, zoomRange.min))}>-</ZoomButton>
				  <input
					id="zoom"
					type="range"
					min={zoomRange.min}
					max={zoomRange.max}
					step="1"
					value={zoom}
					onChange={(e) => handleZoomChange(Number(e.target.value))}
				  />
				  <ZoomButton onClick={() => handleZoomChange(Math.min(zoom + 1, zoomRange.max))}>+</ZoomButton>
					  {/*   <span>Zoom: {zoom.toFixed(1)}</span> */}
					  
				</SectionDiv>
			  )}
			  
			  
			
			  
			{!isIphoneDevice && (supportsFlash || supportsAutofocus) && (
				<SectionDiv>  
					{supportsFlash && (
						<FlashButton active={flashOn} onClick={toggleFlash}>
						  {flashOn ? 'Flash On' : 'Flash Off'}
						</FlashButton>
					)}
					
					{supportsAutofocus && (	  
						<AutofocusButton active={autofocusOn} onClick={toggleAutofocus}>
						  {autofocusOn ? 'Autofocus On' : 'Autofocus Off'}
						</AutofocusButton>	  
					)}
				
				</SectionDiv>
			)}
	
	
	{results.map((item, index) => (
		<ArticleDiv key={item.articolo}>
		
			{item.attivo === 'N' ? (
				<>
					<ArticleNotActive>{item.articolo}: ARTICOLO FUORI PRODUZIONE</ArticleNotActive>
					<hr/>
					<CaptureButton active={captureBtnEnabled} onClick={startCapture}>Nuova scansione</CaptureButton>
				</>
			) : (
				<>
					<ArticleTitle>{item.articolo}: {item.prezzoFormattato}</ArticleTitle>
					<PriceDisclaimer>Prezzo a rivenditore IVA esclusa</PriceDisclaimer>
					<ArticleColumns>
						<ArticleImgContainer>
							<ArticleImg src={`https://b2b.artlineagioielli.it/archivi/${item.pathImmagini[0]}`}/>
						</ArticleImgContainer>
						<ArticleDescContainer>
							  <ArticleDesc>{item.descrizione}</ArticleDesc>
							  {item.tipoVendita === 'peso' && <ArticleNota />}
							  {item.permalink ? (
								<ArticleLink as="a" href={item.permalink}>
								  Dettagli
								</ArticleLink>
							  ) : (
								<ArticleLink as="a" href={`https://artlineagioielli.it/?s=${formatArticleLink(item.articolo)}#inizio-risultati`}>
								  Dettagli
								</ArticleLink>
							  )}
							</ArticleDescContainer>
						<ClearDiv></ClearDiv>
						<hr/>
						<button 
						  onClick={startCapture} 
						  disabled={!captureBtnEnabled} 
						  style={{ border: 'none', background: 'none', padding: 0 }} >
						  <img src={newscan} alt="Nuova scansione" />
						</button>
					</ArticleColumns>
				</>
			)}
		</ArticleDiv>
	))}
	
	
	<div>
      <p style={{ fontSize: '8px', textAlign: 'center', }}>Stato del permesso della fotocamera: {cameraPermission}</p>
      {cameraPermission === 'granted' && <p style={{ fontSize: '8px', textAlign: 'center', }}>Accesso alla fotocamera concesso.</p>}
      {cameraPermission === 'denied' && (
        <p style={{ fontSize: '8px', textAlign: 'center', }}>
          Hai negato l'accesso alla fotocamera. Per favore, modifica le impostazioni del browser per consentire l'accesso.
        </p>
      )}
      {cameraPermission === 'prompt' && <p style={{ fontSize: '8px', textAlign: 'center', }}>Richiedendo l'accesso alla fotocamera...</p>}
      {error && <p style={{ fontSize: '8px', textAlign: 'center',color: 'red' }}>{error}</p>}
    </div>

	
    
	  
	  
    </Wrapper>
  );
}